import type { components, operations } from "./dist/openapi.d.ts";

export type { paths } from "./dist/openapi.d.ts";
import {
  type ExtractResponseBody,
  type ExtractRequestBody,
  castJson,
} from "@saflib/openapi";

/**
 * For typing Express responses for template-service API routes.
 */
export type PowerUpServiceResponseBody = ExtractResponseBody<operations>;

/**
 * For typing Express requests for template-service API routes.
 */
export type PowerUpServiceRequestBody = ExtractRequestBody<operations>;

export type Error = components["schemas"]["Error"];
export type ProductEvent = components["schemas"]["ProductEvent"];
export type ProductEventType = ProductEvent["event"];

// BEGIN SORTED WORKFLOW AREA schema-exports FOR openapi/schema
export type Organization = components["schemas"]["Organization"];
export type OrganizationRequest = components["schemas"]["OrganizationRequest"];
export type Part = components["schemas"]["Part"];
export type PartCondition = Part["condition"];
export type PartFile = components["schemas"]["PartFile"];
export type PartInterestRequest = components["schemas"]["PartInterestRequest"];
export type PartInterestResponse =
  components["schemas"]["PartInterestResponse"];
export type PartRequest = components["schemas"]["PartRequest"];
export type PartSource = components["schemas"]["PartSource"];
export type PartType = components["schemas"]["PartType"];
export type SellInterestRequest = components["schemas"]["SellInterestRequest"];
export type SellInterestResponse =
  components["schemas"]["SellInterestResponse"];
export type ContactRequest = components["schemas"]["ContactRequest"];
export type SupportFeedbackRequest = components["schemas"]["SupportFeedbackRequest"];
export type User = components["schemas"]["User"];
// END WORKFLOW AREA

export type PartTrace = components["schemas"]["part_trace"];

import * as json from "./dist/openapi.json" with { type: "json" };

/**
 * For validating Express requests and responses.
 */
export const jsonSpec = castJson(json);

export const partTypeEnum = (
  jsonSpec?.components?.schemas?.["part-type"] as any
).enum as string[];
